import { IconVariant } from '@/components/icons/types';

export const SOCIAL_BUTTON: {
  [key in 'INSTAGRAM' | 'LINKEDIN' | 'FACEBOOK']: {
    to: string;
    icon: IconVariant;
    alt: string;
  };
} = {
  INSTAGRAM: { to: 'https://instagram.com/bokadirekt_se', icon: 'instagram', alt: 'instagram' },
  LINKEDIN: { to: 'https://www.linkedin.com/company/bokadirekt-i-stockholm-ab/', icon: 'linkedin', alt: 'linkedin' },
  FACEBOOK: { to: 'https://www.facebook.com/bokadirekt', icon: 'facebook', alt: 'facebook' },
} as const;
